const ROLES = {
  administrator: 'administrator',
}

const COLORS = {
  primaryColor: '#6534ff',
}

const ENVIROMENTS = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
}

const STYLES = {
  // Adding #80 to RGB color for 50% opacity
  boxShadow: (color: string) => `0px 10px 30px -5px ${color}80`,
}

const LABELS = {
  issueBadges: {
    roles: [ROLES.administrator],
    title: 'Issue Badges',
  },
  otherTasks: {
    roles: [ROLES.administrator],
    title: 'Other Tasks',
  },
}

const ROUTES = {
  home: '/',
  scan: '/scan/:account',
  scanHome: '/scan',
  redeem: '/redeem/:uid',
  renderToken: '/r/token/:tokenId',
  token: '/token/:tokenId',
  callback: '/callback',
  codeClaimWeb3PageHash: '/claim/:hash/:method',
  codeClaimPageHash: '/claim/:hash',
  codeClaimPage: '/claim',

  websiteClaim: {
    home: {
      path: '/claim-websites/',
      title: 'Enter website name Form',
    },
    claim: {
      path: '/claim-websites/:website',
      title: 'Claim Website with Website name',
    },
  },

  admin: '/backoffice',
  adminLogin: {
    path: '/backoffice/login',
    title: 'Login',
  },
  table: {
    path: '/backoffice/table',
    title: 'Table',
  },
  issueForEvent: {
    path: '/backoffice/issue-for-event',
    roles: [ROLES.administrator],
    title: 'Many Users',
  },
  issueForUser: {
    path: '/backoffice/issue-for-user',
    roles: [ROLES.administrator],
    title: 'Many Events',
  },
  events: {
    path: '/backoffice/events',
    roles: [ROLES.administrator],
    title: 'Manage Drops',
  },
  eventsList: {
    path: '/backoffice/events/list',
    roles: [ROLES.administrator],
  },
  eventsNew: {
    path: '/backoffice/events/new',
    roles: [ROLES.administrator],
  },
  event: {
    path: '/backoffice/events/',
    slug: ':eventId',
    roles: [ROLES.administrator],
  },
  minters: {
    path: '/backoffice/minters',
    roles: [ROLES.administrator],
  },
  burn: {
    path: '/backoffice/burn',
    roles: [ROLES.administrator],
    title: 'Burn Tokens',
  },
  burnToken: {
    path: '/backoffice/burn/:tokenId',
    roles: [ROLES.administrator],
    title: 'Burn Token',
  },
  addressManagement: {
    path: '/backoffice/address-management',
    roles: [ROLES.administrator],
    title: 'Manage Addresses',
  },
  transactions: {
    path: '/backoffice/transactions',
    roles: [ROLES.administrator],
    title: 'Transactions',
  },
  codes: {
    path: '/backoffice/codes',
    roles: [ROLES.administrator],
    title: 'Manage Mint Links',
  },
  adminLogs: {
    path: '/backoffice/logs',
    roles: [ROLES.administrator],
    title: 'Logs',
  },
  codesRequest: {
    path: '/backoffice/requests',
    roles: [ROLES.administrator],
    title: 'Manage Petitions',
  },
  dropRequests: {
    path: '/backoffice/petitions',
    roles: [ROLES.administrator],
    title: 'Manage Petitions',
  },
  draftReviews: {
    path: '/backoffice/petitions/draft-reviews/:draftId',
    roles: [ROLES.administrator],
    title: 'Draft Reviews',
  },

  gpsPetitions: {
    path: '/backoffice/gps-petitions',
    roles: [ROLES.administrator],
    title: 'Manage GPS Petitions',
  },

  drafts: {
    path: '/backoffice/drafts',
    roles: [ROLES.administrator],
    title: 'Manage Drafts',
  },

  deliveries: {
    admin: {
      path: '/backoffice/deliveries',
      roles: [ROLES.administrator],
      title: 'Manage Deliveries',
    },
    newForm: {
      path: '/backoffice/deliveries/new',
      roles: [ROLES.administrator],
      title: 'New Delivery',
    },
    editForm: {
      path: '/backoffice/deliveries/:id',
      roles: [ROLES.administrator],
      title: 'Edit Delivery',
    },
    requests: {
      path: '/backoffice/deliveries/requests',
      roles: [ROLES.administrator],
      title: 'Manage Delivery Requests',
    },
  },

  websites: {
    websitesManage: {
      path: '/backoffice/websites',
      roles: [ROLES.administrator],
      title: 'Manage Websites',
    },
  },

  secret: {
    secretsManage: {
      path: '/backoffice/secrets',
      roles: [ROLES.administrator],
      title: 'Manage Secret Words',
    },
  },
}

const IMAGE_SUPPORTED_FORMATS = ['image/png', 'image/gif', 'image/webp']

const LAYERS = {
  layer1: 'Layer1',
  layer2: 'Layer2',
}

const layerOneNetwork = process.env.REACT_APP_ETH_NETWORK === 'mainnet' ? '' : `${process.env.REACT_APP_ETH_NETWORK}.`
const layerTwoNetwork = process.env.REACT_APP_L2_ETH_NETWORK

const etherscanLinks = {
  tx: (hash: string): string => `https://${layerOneNetwork}etherscan.io/tx/${hash}`,
  address: (address: string): string => `https://${layerOneNetwork}etherscan.io/address/${address}`,
}

const layer2Links = {
  tx: (hash: string): string => {
    if (layerTwoNetwork === 'gnosis') {
      return `https://gnosisscan.io/tx/${hash}`
    } else if (layerTwoNetwork === 'chiado') {
      return `https://blockscout.com/gnosis/chiado/tx/${hash}`
    }
    return `https://blockscout.com/poa/${layerTwoNetwork}/tx/${hash}`
  },
  address: (address: string): string => {
    if (layerTwoNetwork === 'gnosis') {
      return `https://gnosisscan.io/address/${address}`
    } else if (layerTwoNetwork === 'chiado') {
      return `https://blockscout.com/gnosis/chiado/address/${address}`
    }
    return `https://blockscout.com/poa/${layerTwoNetwork}/address/${address}`
  },
}

const LEDGER_EMBEDDED_QUERY_PARAM = 'ledgerEmbed'

const TWITTER_SHARE_BASE_LINK = 'https://twitter.com/intent/tweet'

const MOMENTS_APP_BASE_URL = process.env.REACT_APP_MOMENTS_APP_BASE_URL || ''
const COMPASS_URL = process.env.REACT_APP_COMPASS_URL || ''

export {
  ROLES,
  ROUTES,
  ENVIROMENTS,
  LAYERS,
  etherscanLinks,
  layer2Links,
  LABELS,
  IMAGE_SUPPORTED_FORMATS,
  COLORS,
  STYLES,
  LEDGER_EMBEDDED_QUERY_PARAM,
  TWITTER_SHARE_BASE_LINK,
  COMPASS_URL,
  MOMENTS_APP_BASE_URL,
}
